import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Autocomplete, styled } from '@mui/material';

export const AutocompleteStyled = styled(Autocomplete)(
  ({ theme, fullWidth }) => ({
    width: fullWidth ? '100%' : 200,
    padding: 0,
    '& .MuiTextField-root': {
      paddingRight: 0,
      '& .MuiInputBase-root': {
        paddingRight: `${theme.spacing(2)} !important`,
      },
    },
  }),
);

export const ChevronDownStyled = styled(ChevronDownIcon)(({ theme }) => ({
  '&.MuiSvgIcon-root': {
    width: theme.typography.pxToRem(16.5),
    height: theme.typography.pxToRem(9),
  },
}));

export const IconBoxStyled = styled('div')(({ theme }) => ({
  marginTop: -17,
}));
